import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const CANVAS: ObjectTypeConfig = {
  actions: [
    // Open leads, star second — same order as chats and files.
    {
      id: "open",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "star",
      surfaces: ["left-rail", "context-menu", "card-overlay"],
      presentation: {
        "left-rail": "menu-item",
        "context-menu": "menu-item",
        "card-overlay": "corner-star",
      },
      hiddenWhen: predicates.isFavorite,
    },
    {
      id: "unstar",
      surfaces: ["left-rail", "context-menu", "card-overlay"],
      presentation: {
        "left-rail": "menu-item",
        "context-menu": "menu-item",
        "card-overlay": "corner-star",
      },
      hiddenWhen: { not: predicates.isFavorite },
    },
    {
      id: "rename",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      // Favorites is a lens (rename/file on the canonical row), and a viewer
      // without edit rights doesn't see mutate verbs at all.
      hiddenWhen: { any: [predicates.favoritesScope, predicates.cannotEdit] },
    },
    {
      id: "move",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: { any: [predicates.favoritesScope, predicates.cannotEdit] },
    },
    {
      id: "share",
      surfaces: ["left-rail", "context-menu", "pane-header"],
      presentation: {
        "left-rail": "menu-item",
        "context-menu": "menu-item",
        "pane-header": "icon-button",
      },
      hiddenWhen: predicates.cannotShare,
    },
    {
      id: "delete",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotDelete,
    },
  ],
};
